export var noop = function () { };
export function id(v) {
    return v;
}
//# sourceMappingURL=misc.js.map